import React, { memo } from "react";
import { Stack, Checkbox, Typography } from "@mui/material";
import PropTypes from "prop-types";

const SelectAll = ({ checked, indeterminate, onChange, ariaLabel, label }) => (
  <Stack direction="row" spacing={0.5} alignItems="center">
    <Checkbox
      size="small"
      checked={checked}
      indeterminate={indeterminate}
      onChange={onChange}
      inputProps={{ "aria-label": ariaLabel }}
    />
    <Typography variant="body2" fontWeight={600}>
      {label}
    </Typography>
  </Stack>
);

SelectAll.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  label: PropTypes.string,
};

SelectAll.defaultProps = {
  checked: false,
  indeterminate: false,
  ariaLabel: "select all",
  label: "Select all",
};

export default memo(SelectAll);
